import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import { FormField, Box, Flex, TextField } from '@scale/scaleui-radix';
import useWorkerTeamAdapterCard from './useWorkerTeamAdapterCard';
import { WORKER_TEAM_ADAPTER_INPUT_COLUMNS } from './constants';
import { Filters } from '@scale/compass-ui/components/filters/Filters';
import { COLUMN_ID_TO_OPTIONS } from 'react-scale/corp/views/DataCompassCardsV2/components/filters/inputFilterOptions';

const WorkerTeamAdapterCardComponent: CompassCardComponent = ({
  index,
}: CompassCardComponentProps) => {
  const { filter, setFilter, limit, setLimit } = useWorkerTeamAdapterCard(index);

  return (
    <div className="py-2">
      <div className="space-y-4 mb-3">
        <Box pt="4">
          <Flex direction="column" gap="2" align="end">
            <Filters
              columns={Object.values(WORKER_TEAM_ADAPTER_INPUT_COLUMNS)}
              filters={filter ?? { operator: 'and', filtersOrFilterGroups: [] }}
              setFilters={setFilter}
              columnOptionMap={COLUMN_ID_TO_OPTIONS}
              disabledOperators={['or']}
              disableNested={true}
              disabledConditions={{
                text: ['contains', 'not_contains'],
                number: ['is_empty', 'is_not_empty'],
              }}
              allowZeroFilters={true}
            />
            <FormField.Label>Preview # of teams</FormField.Label>
            <Box maxWidth="70px">
              <TextField.Root
                type="number"
                value={limit}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLimit(e.target.value)}
                placeholder="limit"
                min={1}
              />
            </Box>
          </Flex>
        </Box>
      </div>
    </div>
  );
};

export default WorkerTeamAdapterCardComponent;
